<template>
    <div class="portfolioMovementHistory customScrollbar">
        <table class="table-sm table">
            <thead>
            <tr>
                <th>#</th>
                <th>Description</th>
                <th class="text-right">Price</th>
                <th class="text-right">Total account price</th>
                <th class="text-right" width="160">Date</th>
                <th class="text-right" width="140">Action</th>
            </tr>
            </thead>
            <tbody>
            <template v-if="movementsToLoop.length > 0">
                <tr v-for="(movement, index) in movementsToLoop"
                    :key="`thm_${portfolio.id}_${index}`">
                    <td>{{movementsToLoop.length - index}}</td>
                    <td>{{(movement.description && movement.description.length > 80 ?
                        `${movement.description.slice(0,80)}...` : movement.description)}}
                    </td>
                    <td class="text-right">{{parseFloat(movement.price).toFixed(currency.decimal_digits)}}
                        {{currency.symbol}}
                    </td>
                    <td class="text-right">{{priceUntilIndex(index).toFixed(currency.decimal_digits)}}
                        {{currency.symbol}}
                    </td>
                    <td class="text-right">{{dayjs(movement.date).format('YYYY-MM-DD')}}</td>
                    <td class="text-right">
                        <b-button class="text-info" size="sm" @click="editBankMoveItem(portfolio, movement)">
                            <fa-icon icon="pencil-alt"/>
                        </b-button>
                        <b-button class="text-danger" size="sm" @click="removeMovement(movement)">
                            <fa-icon :icon="['far', 'trash-alt']"/>
                        </b-button>
                    </td>
                </tr>
            </template>
            <tr v-else>
                <b-alert variant="info">No movement found</b-alert>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import dayjs from "dayjs";

    export default {
        name: "historyTableMovements",
        props: ['portfolio', 'currency', 'editBankMoveItem', 'user'],
        computed: {
            dayjs() {
                return dayjs;
            },
            movementsToLoop() {
                return this.portfolio && this.portfolio.moves ? this.portfolio.moves.slice().sort((a, b) => a.date < b.date ? 1 : -1) : []
            }
        },
        methods: {
            priceUntilIndex(index) {
                return this.movementsToLoop.filter((movement, cindex) => {
                    return cindex >= index;
                }).reduce((p, c) => {
                    return p + parseFloat(c.price);
                }, 0);
            },
            removeMovement(movement) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value && this.user && this.portfolio) {

                        this.$firebase.database().ref(`portfolio/${this.user.uid}/${this.portfolio.id}/_moves/${movement.id}`).remove((err) => {
                            console.log(err);
                            if (err === null) {
                                this.$swal(
                                    'Deleted!',
                                    'Your file has been deleted.',
                                    'success'
                                )
                            } else {
                                this.$swal(
                                    'Error!',
                                    'Unable to delete: ' + err.message,
                                    'error'
                                )
                            }
                        });

                    }
                });
            }
        }
    }
</script>
